module.exports = __webpack_public_path__ + "static/img/kssd-logo.ab662c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kssd-logo.png
// module id = YDvq
// module chunks = 1